// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_E0VLr","space21":"index_space21_OIlFn","space50":"index_space50_iCz-b"};